import { SETTINGS_DATA_SOURCE_TYPES } from "@infinode/components/settings/constants";
import { Record } from "immutable";

const EnergyDataItemRecord = Record({
  timestamp: null, // timestamp
  [SETTINGS_DATA_SOURCE_TYPES.NET_IMPORT]: null,
  [SETTINGS_DATA_SOURCE_TYPES.CONSUMED]: null,
  [SETTINGS_DATA_SOURCE_TYPES.GENERATED]: null,
  [SETTINGS_DATA_SOURCE_TYPES.STORAGE]: null
});

const createEnergyDataItemRecord = dataItem => {
  return EnergyDataItemRecord(dataItem);
};

export { createEnergyDataItemRecord };

export default EnergyDataItemRecord;
